import React from'react';import PropTypes from'prop-types';import styled from'styled-components';import {useIntl}from'react-intl';import {BREAKPOINTS,Modal,BUTTON_VARIANT}from'@manulife/mux';import CoBrandingButton from'../CoBranding/CoBrandingButton.js';var ModalWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "YesNoModal__ModalWrapper",
  componentId: "sc-11ig4hm-0"
})(["text-align:center;padding-bottom:16px;"]);
var ModalContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "YesNoModal__ModalContent",
  componentId: "sc-11ig4hm-1"
})(["width:414px;margin:auto;@media (max-width:", "px){width:330px;}@media (max-width:", "px){width:302px;}"], BREAKPOINTS.TABLET_PORTRAIT, BREAKPOINTS.PHONE_PORTRAIT_MED);
var ModalButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "YesNoModal__ModalButtonWrapper",
  componentId: "sc-11ig4hm-2"
})(["display:flex;flex-flow:row nowrap;justify-content:space-between;width:100%;"]);
var modalButtonStyle = {
  buttonStyle: {
    minWidth: '192px',
    media: [{
      maximum: BREAKPOINTS.TABLET_PORTRAIT,
      minWidth: '149px'
    }, {
      maxmium: BREAKPOINTS.PHONE_PORTRAIT_MED,
      minWidth: '137px'
    }]
  }
};
var YesNoModal = function YesNoModal(_ref) {
  var showModal = _ref.showModal,
    onNo = _ref.onNo,
    onYes = _ref.onYes,
    noText = _ref.noText,
    yesText = _ref.yesText,
    children = _ref.children,
    ariaLabelledById = _ref.ariaLabelledById;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showModal,
    showCloseButton: false,
    ariaLabelledBy: ariaLabelledById
  }, /*#__PURE__*/React.createElement(ModalWrapper, null, /*#__PURE__*/React.createElement(ModalContent, null, children, /*#__PURE__*/React.createElement(ModalButtonWrapper, null, /*#__PURE__*/React.createElement(CoBrandingButton, {
    id: "noButton",
    customStyle: modalButtonStyle,
    variant: BUTTON_VARIANT.SECONDARY,
    onClick: onNo
  }, noText || intl.formatMessage({
    id: 'shared.global.no'
  })), /*#__PURE__*/React.createElement(CoBrandingButton, {
    id: "yesButton",
    customStyle: modalButtonStyle,
    onClick: onYes
  }, yesText || intl.formatMessage({
    id: 'shared.global.yes'
  }))))));
};
process.env.NODE_ENV !== "production" ? YesNoModal.propTypes = {
  showModal: PropTypes.bool,
  onNo: PropTypes.func.isRequired,
  onYes: PropTypes.func.isRequired,
  noText: PropTypes.node,
  yesText: PropTypes.node,
  children: PropTypes.node.isRequired,
  ariaLabelledById: PropTypes.string.isRequired
} : void 0;
YesNoModal.defaultProps = {
  showModal: false,
  noText: null,
  yesText: null
};
var YesNoModal$1 = YesNoModal;export{YesNoModal$1 as default,modalButtonStyle};